import "./styles.css";

const ModalWrapper = ({ open, onClose, children }) => {
  if (!open) return null;
  return (
    <div className="glass-modal-bg" onClick={onClose}>
      <div className="glass-modal-main" onClick={e => e.stopPropagation()}>
        <button className="glass-modal-close" onClick={onClose} title="Zamknij">&times;</button>
        {children}
      </div>
    </div>
  );
};


export default ModalWrapper;
